import type { Meta, StoryFn } from '@storybook/react';

import { EmptyState } from '@pega/cosmos-react-core';
import type { EmptyStateProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/EmptyState',
  component: EmptyState,
  parameters: {
    layout: 'centered'
  }
} as Meta;

export const EmptyStateDemo: StoryFn<EmptyStateProps> = (args: EmptyStateProps) => {
  return <EmptyState message={args.message} />;
};

EmptyStateDemo.args = {
  message: 'No items'
};

EmptyStateDemo.argTypes = {
  message: { control: { type: 'text' } }
};
